module.exports = "<main class=\"popups success\" align=\"center\">\n  <h2 class=\"capitalize\">{{operationName}}</h2>\n  {{message}}\n    <br><br>\n    <button type=\"button\" class=\"btn btn-sm btn-popups uppercase\" style=\"width:150px\" (click)=\"execute()\">okay</button>\n    <button type=\"button\" class=\"btn btn-sm btn-popups capitalize\" style=\"width:150px\" (click)=\"closeModal()\">cancel</button>\n  </main>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/modals/callback-modal/callback-modal.component.html
// module id = ./src/app/achelos-iot/modals/callback-modal/callback-modal.component.html
// module chunks = main